function initMediaListSwipers(root = document) {
  if (typeof Swiper === 'undefined') return;

  root.querySelectorAll('[data-media-list-swiper]').forEach((carouselEl) => {
    if (carouselEl.swiper) return;

    new Swiper(carouselEl, {
      slidesPerView: 7,
      spaceBetween: 50,
      loop: true,
      speed: 3000,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      breakpoints: {
        1200: { slidesPerView: 7, spaceBetween: 50 },
        1000: { slidesPerView: 5, spaceBetween: 50 },
        749: { slidesPerView: 4, spaceBetween: 50 },
        300: { slidesPerView: 2.6, spaceBetween: 25 },
      },
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initMediaListSwipers();
});

document.addEventListener('shopify:section:load', (event) => {
  initMediaListSwipers(event.target);
});
